<!--托运单-->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div id="formHtml" style="padding:30px 30px;color:#000000">
      <div style="background:#1c1c1c;">
        <table cellspacing="1" cellpadding="0" width="100%" >

          <tr >
            <td colspan="5" ><h2>撬装加油装置受油信息报送表</h2></td>
          </tr>
          <tr>
            <td rowspan="3" width="100">发货信息</td>
            <td width="120">单位名称</td>
            <td width="220"><input type="text" v-model="form.consignorUnitName" :class="edit(form.consignorUnitName)"/></td>
            <td rowspan="3" width="120">油库地址</td>
            <td rowspan="3"><input type="text" v-model="form.consignorOilAddr" :class="edit(form.consignorOilAddr)"/></td>
          </tr>
          <tr>
            <td>联系电话</td>
            <td><input type="text" v-model="form.consignorContact" :class="edit(form.consignorContact)"/></td>
          </tr>
          <tr>
            <td>柴油（升）</td>
            <td><input type="number" v-model="form.consignorVolume" :class="edit(form.consignorVolume)"/></td>
          </tr>
          <tr>
            <td rowspan="4">收货信息</td>
            <td>单位名称</td>
            <td><input type="text" v-model="form.harvestUnitName" :class="edit(form.harvestUnitName)"/></td>
            <td rowspan="3">撬装设立地址</td>
            <td rowspan="3"><input type="text" v-model="form.harvestOilAddr" :class="edit(form.harvestOilAddr)"/></td>
          </tr>
          <tr>
            <td>联系电话</td>
            <td><input type="text" v-model="form.harvestContact" :class="edit(form.harvestContact)"/></td>
          </tr>
          <tr>
            <td>柴油（升）<span style="color:red">*</span></td>
            <td><input type="number" v-model="form.harvestVolume" :class="edit(form.harvestVolume)"/></td>
          </tr>
          <tr>
            <td>撬装编号<span style="color:red">*</span></td>
            <td><input type="text" v-model="form.oilEdequipmentCode" :class="edit(form.oilEdequipmentCode)"/></td>
            <td>受油时间<span style="color:red">*</span></td>
            <td>
              <el-date-picker
                  v-model="form.injectionTime"
                  type="datetime"
                  placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td rowspan="2">承运信息</td>
            <td>单位名称</td>
            <td><input type="text" v-model="form.carryUnitName" :class="edit(form.carryUnitName)"/></td>
            <td>联系电话</td>
            <td><input type="text" v-model="form.carryTel" :class="edit(form.carryTel)"/></td>
          </tr>
          <tr>
            <td>车牌号码</td>
            <td><input type="text" v-model="form.carryCarno" :class="edit(form.carryCarno)"/></td>
            <td>罐体容积</td>
            <td><input type="number" v-model="form.carryVolume" :class="edit(form.carryVolume)"/></td>
          </tr>
          <tr>
            <td colspan="5">
              <div style="padding:10px;" v-if="!preview">
                <upload-component v-on:on-upload="(e)=>{form.inRecordFile=e.fileSerial;form.inRecordFileName=e.fileName;}" :fileSerial="form.inRecordFile" :fileName="form.inRecordFileName" :show="'true'" :key="form.inRecordFile">
                  <template v-slot:default>
                    <span style="font-size:10px">上传现场受油画面(请上传图片)</span> 
                  </template>
                </upload-component>
              </div>
              <div v-else style="padding:10px;">
                <img :src="previewUrl" style="width:100%;"/>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div  class="dialog-footer" style="margin-top:10px;text-align: center;">
      <el-button @click="closeDialog()"  size="small">取 消</el-button>
      <el-button  size="small" type="primary" v-if="!preview"  @click="create('form')">保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  addObj,
  getObj,
  putObj
} from '../../../api/admin/sysOilEdequipmentInrecord/index';
import {enterpriseDetail} from "../../../api/admin/sysEnterprise";
import uploadComponent from '../common/upload-com.vue'
import {filePreview} from "../../../api/admin/sysFiles/index";
export default {
  components:{
      uploadComponent
  },
  name: 'oilInrecordForm',
  props:["formId", "prop", "preview"],
  data() {
    return {
      editStatus:true,
      form:{
        recordId: null,
        oilEdequipmentCode:null,
        oilType: 1,
        injectionVolume: null,
        injectionWeight: null,
        injectionTime: null,
        acquisitionType: null,
        addTime: null,
        lastTime: null,
        isDel: null,
        dataType: null,
        consignorUnitName: null,
        consignorContact: null,
        consignorOilAddr: null,
        consignorVolume: null,
        harvestUnitName: null,
        harvestContact: null,
        harvestOilAddr: null,
        harvestVolume: null,
        carryUnitName: null,
        carryTel: null,
        carryCarno: null,
        carryVolume: null,
        inRecordFile: null,
        inRecordFileName: null,
      },
      previewUrl:null,
    }
  },
    created() {
        console.log("formId:"+this.formId+"   "+this.preview);
        this.init();
    },
    computed: {
        ...mapGetters([
            'elements'
        ])
    },
    methods: {
      dateFormat:function(date){
        let t=new Date(date);//row 表示一行数据, updateTime 表示要格式化的字段名称
        return t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+" "+t.getHours()+":"+t.getMinutes()+":"+t.getSeconds();
      },
      init: function () {
          let self = this;
          if(this.formId){
            getObj(this.formId).then(response=>{
                self.form=response;
                self.imageUrl(this.form.inRecordFile).then(url=>{
                    self.previewUrl = url;
                })
            })
          }else {
              enterpriseDetail({}).then(response => {
                  this.form.entName = response.entName;
              });
          }
      },
      imageUrl:function(fileSerials){
          if(!fileSerials || fileSerials.length<=0){
              return Promise.resolve("");
          }
          return new Promise((reslove, reject)=>{
              filePreview(fileSerials).then(url => {
                  reslove(url);
              })
          });
      },
      create() {
        if(!this.form.oilEdequipmentCode){
          this.$notify({
            title: '警告',
            message: '撬装编号不能为空',
            type: 'warning'
          });
          return;
        }else if(!this.form.harvestVolume){
          this.$notify({
            title: '警告',
            message: '收货信息，柴油（升）不能为空',
            type: 'warning'
          });
          return;
        }else if(!this.form.injectionTime){
          this.$notify({
            title: '警告',
            message: '受油时间不能为空',
            type: 'warning'
          });
          return;
        }else{
          this.editStatus = false;
          this.$nextTick(()=>{
            this.form.injectionTime = this.dateFormat(this.form.injectionTime);
            addObj(this.form).then((response) => {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000
              });
              this.$emit("on-success");
            })
          })
        }

      },
    edit:function(val){ 
      if(val && String.valueOf(val).length>0){
        return "edit";
      }
      return "";
    },
    closeDialog(){
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
table td {background:#FFF;padding:0px 4px;height:40px;box-sizing:border-box;text-align:center;}
table td .checkbox{width:16px;height:16px;border:solid 1px #000;background:#FFF;position:relative;top:3px;}
table td input{ display:inline-block;background:url(./img/edit.png) 10px no-repeat;width:100%;height:100%;border:none;text-indent:0px;border:none;font-size:14px;outline:none;padding-left:10px;box-sizing: border-box;}
table td .shortInput{ width:60px;height:100%;border:none;}
table td .longInput{ width:290px;height:100%;border:none;}
.edit{background:transparent;text-align:left;}
table td input.el-input__inner{border:none}
</style>